import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWorkoutTemplateApi } from "../../api/workoutTemplateApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchWorkoutTemplateThunk = createAsyncThunk(
  Endpoints.GET_WORKOUT_TEMPLATE_LIST,
  async (coachId, { rejectWithValue }) => {
    try {
      const data = await fetchWorkoutTemplateApi(coachId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const workoutTemplateSlice = createSlice({
  name: "getWorkoutTemplate",
  initialState: {
    workoutTemplate: null,
    workoutTemplateIsloading: false,
    failedtoFetch: false,
    error: null,
    successMessage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutTemplateThunk.pending, (state) => {
        state.workoutTemplateIsloading = true;
        state.error = null;
        state.failedtoFetch = false;
      })
      .addCase(fetchWorkoutTemplateThunk.fulfilled, (state, action) => {
        state.workoutTemplateIsloading = false;
        state.workoutTemplate = action.payload;
        if (action.payload.totalCount == 0) {
          state.failedtoFetch = true;
        }
        state.failedtoFetch = false;
      })
      .addCase(fetchWorkoutTemplateThunk.rejected, (state, action) => {
        state.workoutTemplateIsloading = false;
        state.error = action.payload;
        state.failedtoFetch = false;
      });
  },
});

export const workoutTemplateReducer = workoutTemplateSlice.reducer;
